var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddCardsTopActiveIcon(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 169,
    viewBox: "0 0 123 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: -3,
    y: 59.5,
    width: 99,
    height: 130,
    rx: 10,
    transform: "rotate(-30 -3 59.5)",
    fill: "#C2E6D1",
    style: (_ref2 = {
      fill: "#C2E6D1"
    }, _defineProperty(_ref2, "fill", "color(display-p3 0.7608 0.9020 0.8196)"), _defineProperty(_ref2, "fillOpacity", 1), _ref2)
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.7344,
    y: 23.625,
    width: 99,
    height: 130,
    rx: 10,
    transform: "rotate(-15 31.7344 23.625)",
    fill: "#C2E6D1",
    style: (_ref3 = {
      fill: "#C2E6D1"
    }, _defineProperty(_ref3, "fill", "color(display-p3 0.7608 0.9020 0.8196)"), _defineProperty(_ref3, "fillOpacity", 1), _ref3)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8594 58.2461L104.357 89.961",
    stroke: "#3AB67D",
    style: (_ref4 = {
      stroke: "#3AB67D"
    }, _defineProperty(_ref4, "stroke", "color(display-p3 0.2275 0.7137 0.4902)"), _defineProperty(_ref4, "strokeOpacity", 1), _ref4),
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.25 78.3555L115.965 69.8575",
    stroke: "#3AB67D",
    style: (_ref5 = {
      stroke: "#3AB67D"
    }, _defineProperty(_ref5, "stroke", "color(display-p3 0.2275 0.7137 0.4902)"), _defineProperty(_ref5, "strokeOpacity", 1), _ref5),
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCardsTopActiveIcon);
export default __webpack_public_path__ + "static/media/addCardsTopActiveIcon.78fc62de.svg";
export { ForwardRef as ReactComponent };